module.exports = __webpack_public_path__ + "80a6f4c48d075461e06bb0201b53f43f.pdf";